import { getErrorMessage } from "app/error";

export interface ApiResponse<T = any> {
  headers: {[key: string]: string};
  status: number;
  statusText: string;
  data: T;
  hasError(): boolean
}

export interface ApiRequestConfig {
  headers?: ApiHeaders
}

interface ApiHeaders {
  [key: string]: ApiHeaderValue
}

type ApiHeaderValue = string | string[] | number | boolean | null;

export interface IApiClient {
  get<TResponse = any>(
    path: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>>;
  post<TRequest = any, TResponse = any>(
    path: string,
    object: TRequest,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>>;
  put<TRequest = any, TResponse = any>(
    path: string,
    object: TRequest,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>>;
  delete<TResponse = any>(
    path: string,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TResponse>>;
}

export class ApiResponseClass<T = any> implements ApiResponse {
  headers: {[key: string]: string};
  status: number;
  statusText: string;
  data: T;
  
  constructor(
    headers: {[key: string]: string},
    status: number,
    statusText: string,
    data: T) {
      this.headers = headers;
      this.status = status;
      this.statusText = statusText;
      this.data = data;
    }

    hasError(): boolean {
      return this.status >= 400;
    }
}

export function createApiResponseFromCaughtError<T = any>(error: unknown) : ApiResponse<T> {
  var headers: {[key: string]: string;} = {};
  var statusText = getErrorMessage(error);
  return new ApiResponseClass(
    headers,
    500,
    statusText,
    {} as T
  );
}